/*
 * @Author: freedeng
 * @Date: 2019-07-09 11:20:29
 * @Last Modified by: freedeng
 * @Last Modified time: 2019-07-09 15:39:49
 */
export var SyncResultCode;
(function (SyncResultCode) {
    SyncResultCode[SyncResultCode["UnknownError"] = -1] = "UnknownError";
    SyncResultCode[SyncResultCode["Success"] = 0] = "Success";
    SyncResultCode[SyncResultCode["NoGlobalPadIdError"] = -1001] = "NoGlobalPadIdError";
    SyncResultCode[SyncResultCode["InvalidFileTypeError"] = -1002] = "InvalidFileTypeError";
    SyncResultCode[SyncResultCode["InvalidUrlError"] = -1003] = "InvalidUrlError";
    SyncResultCode[SyncResultCode["PreloadParseError"] = -1004] = "PreloadParseError";
    SyncResultCode[SyncResultCode["AIOUrlTypeError"] = -1005] = "AIOUrlTypeError";
    SyncResultCode[SyncResultCode["GetDocumentStatusError"] = -2001] = "GetDocumentStatusError";
    SyncResultCode[SyncResultCode["RejcectByThrottleError"] = -2002] = "RejcectByThrottleError";
    SyncResultCode[SyncResultCode["GetDocLockError"] = -2003] = "GetDocLockError";
    SyncResultCode[SyncResultCode["GetUncommitDataError"] = -2004] = "GetUncommitDataError";
    SyncResultCode[SyncResultCode["CreateFileError"] = -2005] = "CreateFileError";
    SyncResultCode[SyncResultCode["CommitOfflineDataError"] = -2006] = "CommitOfflineDataError";
    SyncResultCode[SyncResultCode["UpdateUnCommitedDataError"] = -2007] = "UpdateUnCommitedDataError";
    SyncResultCode[SyncResultCode["PreFetchDocDataError"] = -2008] = "PreFetchDocDataError";
    SyncResultCode[SyncResultCode["UpdatePreFetchOfflienDataError"] = -2009] = "UpdatePreFetchOfflienDataError";
    SyncResultCode[SyncResultCode["UpdatePadInfoError"] = -2010] = "UpdatePadInfoError";
    SyncResultCode[SyncResultCode["SyncOfflineDataUnknownError"] = -2011] = "SyncOfflineDataUnknownError";
    SyncResultCode[SyncResultCode["PadInfoNotExistError"] = -2012] = "PadInfoNotExistError";
    SyncResultCode[SyncResultCode["FileNotExsitError"] = -2013] = "FileNotExsitError";
    SyncResultCode[SyncResultCode["HttpStatusError"] = -2014] = "HttpStatusError";
    SyncResultCode[SyncResultCode["DocumentBlankPageError"] = -2015] = "DocumentBlankPageError";
})(SyncResultCode || (SyncResultCode = {}));
var ErrorSyncResult = /** @class */ (function () {
    function ErrorSyncResult(resultCode, message, error, subResultCode) {
        // 细分错误码
        this.subResultCode = -1;
        this.resultCode = resultCode;
        this.message = message || SyncResultCode[resultCode];
        if (subResultCode !== undefined) {
            this.subResultCode = subResultCode;
        }
        this.error = error;
    }
    return ErrorSyncResult;
}());
export { ErrorSyncResult };
//# sourceMappingURL=Interface.js.map